import classNames from 'classnames';
import React from 'react';
import { UFBNoticeImpressionEvent } from '@udemy/browse-event-tracking';
import { Tracker, TrackImpression } from '@udemy/event-tracking';
import { Avatar, Image } from '@udemy/react-core-components';
import { safelySetInnerHTML } from '@udemy/shared-utils';
import { udLink } from '@udemy/ud-data';
import { LearningTestimonialType } from '../graphql/api-platform-graphql';
import { TestimonialImpressionEvent } from './events';
import styles from "./learning-testimonial-card.module.css";
import { getTestimonialEventTypeFromSchemaType } from './utils/get-testimonial-event-types';
export const LearningTestimonialCard = ({
  children,
  content,
  contentUrlOnClick,
  id,
  relatedUrl,
  source,
  type,
  uiRegion = '',
  className = '',
  size = 'medium'
}) => {
  const trackImpression = () => {
    const eventData = {
      id,
      // We need to map the schema type to the event type
      type: getTestimonialEventTypeFromSchemaType(type),
      uiRegion
    };
    Tracker.publishEvent(new TestimonialImpressionEvent(eventData));
    if (type === LearningTestimonialType.CaseStudy) {
      Tracker.publishEvent(new UFBNoticeImpressionEvent({
        placement: uiRegion,
        url: relatedUrl
      }));
    }
  };

  /**
   * This function renders the source details for the testimonial which can be a user, a website or a company
   * @param type - The type of testimonial
   */
  const renderSourceDetails = type => {
    const {
      name,
      description = '',
      image,
      initials
    } = source;
    if (type === LearningTestimonialType.ThirdParty) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles['source-medium']
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(styles['source-details'], styles[size])
      }, /*#__PURE__*/React.createElement("img", {
        src: image,
        alt: ''
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames(styles[`source-details`], styles[size])
      }, /*#__PURE__*/React.createElement("span", safelySetInnerHTML({
        descriptionOfCaller: 'learning-testimonial-card:source-title',
        html: description
      }))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles['source-small']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['source-avatar']
    }, /*#__PURE__*/React.createElement(Avatar, {
      alt: "NONE",
      size: size,
      srcKey: "image75x75",
      user: {
        image75x75: image,
        initials: initials
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles['source-details'], styles[size])
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['source-name'],
      "data-purpose": "source-name"
    }, name), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles['source-title'], styles[size]),
      "data-purpose": "source-title"
    }, /*#__PURE__*/React.createElement("span", safelySetInnerHTML({
      descriptionOfCaller: 'learning-testimonial-card:source-title',
      html: description
    })))));
  };
  const renderContent = () => {
    const onClickWrapper = event => {
      const target = event.target;

      /**
       * Since the content is directly coming from CMS, for the sake of simplicity and safety (don't need to parse
       * incoming data), we're just looking a tag clicks
       */
      if (target.tagName.toLowerCase() === 'a') {
        const href = target.href;
        contentUrlOnClick === null || contentUrlOnClick === void 0 || contentUrlOnClick(href);
      }
    };
    return /*#__PURE__*/React.createElement("span", Object.assign({
      className: classNames(styles['content'], {
        'ud-text-sm': size === 'medium',
        'ud-text-lg': size === 'large'
      })
    }, safelySetInnerHTML({
      descriptionOfCaller: 'testimonial:content',
      html: content,
      dataPurpose: 'injected-testimonial-content',
      /**
       * Need to add target to the list of allowed attributes for the sanitizer. Otherwise links that need
       * to be opened in the new window won't work
       */
      domPurifyConfig: {
        ADD_ATTR: ['target']
      }
    }), {
      onClick: onClickWrapper
    }));
  };
  return /*#__PURE__*/React.createElement(TrackImpression, {
    trackFunc: trackImpression
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.card, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['testimonial-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['testimonial'], {
      [styles['large']]: size === 'large'
    })
  }, /*#__PURE__*/React.createElement(Image, {
    src: udLink.toStorageStaticAsset('browse_components/student-quote-unit/quote.svg'),
    alt: "",
    width: size === 'large' ? 35.56 : 17.78,
    height: size === 'large' ? 32 : 16
  }), /*#__PURE__*/React.createElement("div", null, renderContent())), renderSourceDetails(type)), children && /*#__PURE__*/React.createElement("div", {
    className: styles['cta-container']
  }, children))));
};
//# sourceMappingURL=learning-testimonial-card.react-component.js.map